import { forwardRef } from 'react';
import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    return (
        <SvgIcon ref={ref} {...props}>
            <path d='M19.101 6.6H13.017C12.333 6.6 11.712 6.213 11.406 5.601L10.605 3.99C10.29 3.387 9.66899 3 8.98499 3H4.70101C3.71101 3 3 3.81 3 4.8V19.2C3 20.19 3.70201 21 4.70101 21H19.101C20.091 21 21 20.19 21 19.2V8.4C21 7.41 20.091 6.6 19.101 6.6ZM19.2 18.3C19.2 18.795 18.696 19.2 18.201 19.2H5.60101C5.10601 19.2 4.8 18.795 4.8 18.3V12H19.2V18.3ZM19.2 10.2H4.8C4.8 8.202 4.8 7.698 4.8 5.7C4.8 5.205 5.10601 4.8 5.60101 4.8H8.625C8.967 4.8 9.28199 4.998 9.43499 5.304L10.461 7.392C10.767 8.013 11.388 8.4 12.081 8.4H18.21C18.705 8.4 19.209 8.805 19.209 9.3V10.2H19.2Z' />
        </SvgIcon>
    );
});
